import { breakpoints } from '@bnnvara/breakpoints';
import { ThemeIcon } from '@bnnvara/icons/src/components/UserInterfaceIcons/Theme';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { typography, space } from 'styled-system';

const StyledThemeTagCard = styled.span`
  display: inline-flex;
  align-items: center;
  color: ${({ color }) => color};
  font-size: 10px;
  font-weight: 700;
  line-height: 10px;

  ${breakpoints.md} {
    border-radius: 2px;
    color: ${({ theme, color, variant }) =>
      variant === 'default' ? theme.base.white : color};
    font-size: 12px;
    font-weight: 700;
    line-height: 10px;
  }

  svg {
    height: 14px;
    width: 8px;
    padding-right: 4px;
    * {
      fill: ${({ color }) => color};
    }
    ${breakpoints.md} {
      width: 4px;
      height: 20px;
      padding-right: 8px;
    }
  }

  ${space}
  ${typography}
  text-transform: ${({ textTransform }) => textTransform};
`;

export const ThemeTagCard = ({
  children,
  color,
  variant,
  textTransform,
  ...props
}) => {
  return (
    <StyledThemeTagCard
      color={color}
      textTransform={textTransform}
      variant={variant}
      {...props}
    >
      <ThemeIcon />
      {children}
    </StyledThemeTagCard>
  );
};

ThemeTagCard.defaultProps = {
  textTransform: 'uppercase',
  variant: 'default',
};

ThemeTagCard.propTypes = {
  children: PropTypes.node.isRequired,
  iconLeft: PropTypes.node,
  color: PropTypes.string,
  textTransform: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'profile']),
};
